import React from 'react';
import PropTypes from 'prop-types';

let InstanceIDCounter = 0;

export default class OEMouseTracker extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.instanceID = '-ID' + InstanceIDCounter.toString();
        InstanceIDCounter++;

        this.mouseState = 0;

        //console.log('OEMouseTracker instance ID - ' + this.instanceID);

        this.onMouseDown = this.onMouseDown.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
    }

    changeMouseState(state, props) {
        if(this.mouseState === state)   return;
        this.mouseState = state;
        props = props || this.props;
        if(props.onMouseState) props.onMouseState(state);
    }

    componentWillUnmount()    {
        this.mouseDestroy();
    }

    componentDidMount()    {
        this.mouseInit();
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.element !== this.props.element || nextProps.name !== this.props.name)     {
            this.mouseDestroy();
            this.mouseInit(nextProps);
        } else if(nextProps.disabled != this.props.disabled && nextProps.disabled) {
            if(nextProps.disabled)  {
                this.mouseDestroy();
            } else {
                this.mouseInit(nextProps);
            }
        }
    }

    mouseInit(props)    {
        if(this.props.disabled) return;

        props = props || this.props;
        if(props.element)   {
            $(props.element).on('mousedown.' + props.name + this.instanceID, this.onMouseDown);
            $(props.element).on('touchstart.' + props.name + this.instanceID, this.onTouchStart);
        }

        this.activeMouse = undefined;
        this.activeTouch = undefined;
        this.changeMouseState(0, props);
    }

    mouseDestroy(props) {
        props = props || this.props;
        if(props.element)   {
            $(props.element).off( '.' + props.name + this.instanceID);
        }
        
        if(this.mouseMoveDelegate)  $(document).off('mousemove.' + props.name + this.instanceID, this.mouseMoveDelegate);
        if(this.mouseUpDelegate)  $(document).off('mouseup.' + props.name + this.instanceID, this.mouseUpDelegate);
        if(this.touchMoveDelegate)  $(document).off('touchmove.' + this.props.name + this.instanceID, this.touchMoveDelegate);
        if(this.touchEndDelegate)  $(document).off('touchend.' + this.props.name + this.instanceID, this.touchEndDelegate);
        if(this.touchEndDelegate)  $(document).off('touchcancel.' + this.props.name + this.instanceID, this.touchEndDelegate);

        this.mouseMoveDelegate = undefined;
        this.mouseUpDelegate = undefined;
        this.touchMoveDelegate = undefined;
        this.touchEndDelegate = undefined;

        this.changeMouseState(0, props);
    }

    updateActiveTouch(event)  {
        if(!event.changedTouches || !this.activeTouch)   return false;
        for(let i = 0; i < event.changedTouches.length; ++i)    {
            if(event.changedTouches[i].identifier === this.activeTouch.identifier)    {
                this.activeTouch = event.changedTouches[i];
                return true;
            }
        }
        return false;
    }

    onMouseDown(event)    {
        if(event.buttons !== 1)  return;

        if(this.activeMouse)   this.onMouseUp(this.activeMouse, true);
        if(this.activeTouch)    this.onTouchEnd();

        this.activeMouse = event;

        this.mouseMoveDelegate = this.onMouseMove.bind(this);
        this.mouseUpDelegate = this.onMouseUp.bind(this);

        $(document).on('mousemove.' + this.props.name + this.instanceID, this.mouseMoveDelegate);
        $(document).on('mouseup.' + this.props.name + this.instanceID, this.mouseUpDelegate);

        this.changeMouseState(1);

        if(this.props.onMouseDown)  this.props.onMouseDown({x: event.clientX, y: event.clientY});

        //console.log('mouse down');
    }

    onMouseMove(event)  {
        if(!this.activeMouse || !(event.buttons & 1))  return;
        if(this.props.onMouseMove)  this.props.onMouseMove({x: event.clientX, y: event.clientY});
    }

    onMouseUp(event, force)    {
        if((event.buttons & 1) && !force)  return;

        if(this.mouseMoveDelegate)  $(document).off('mousemove.' + this.props.name + this.instanceID, this.mouseMoveDelegate);
        if(this.mouseUpDelegate)  $(document).off('mouseup.' + this.props.name + this.instanceID, this.mouseUpDelegate);

        this.mouseMoveDelegate = undefined;
        this.mouseUpDelegate = undefined;

        this.changeMouseState(0);

        if(this.activeMouse)   {
            this.activeMouse = undefined;
            if(this.props.onMouseUp)  this.props.onMouseUp({x: event.clientX, y: event.clientY});
        }

        //console.log('mouse up');
    }

    onTouchStart(event) {
        if(this.activeMouse)   this.onMouseUp(this.activeMouse, true);
        if(this.activeTouch)    this.onTouchEnd();

        if(!event.changedTouches || !event.changedTouches.length)   return;

        this.activeTouch = event.changedTouches[0];

        this.touchMoveDelegate = this.onTouchMove.bind(this);
        this.touchEndDelegate = this.onTouchEnd.bind(this);

        $(document).on('touchmove.' + this.props.name + this.instanceID, this.touchMoveDelegate);
        $(document).on('touchend.' + this.props.name + this.instanceID, this.touchEndDelegate);
        $(document).on('touchcancel.' + this.props.name + this.instanceID, this.touchEndDelegate);

        this.changeMouseState(1);

        if(this.props.onMouseDown)  this.props.onMouseDown({x: this.activeTouch.clientX, y: this.activeTouch.clientY});

        //console.log('touch start');
    }

    onTouchMove(event)  {
        if(!this.updateActiveTouch(event))    return;
        if(this.props.onMouseMove)  this.props.onMouseMove({x: this.activeTouch.clientX, y: this.activeTouch.clientY});
    }

    onTouchEnd(event)  {
        if(!this.activeTouch || (event && !this.updateActiveTouch(event)))    return;
        
        if(this.touchMoveDelegate)  $(document).off('touchmove.' + this.props.name + this.instanceID, this.touchMoveDelegate);
        if(this.touchEndDelegate)  $(document).off('touchend.' + this.props.name + this.instanceID, this.touchEndDelegate);
        if(this.touchEndDelegate)  $(document).off('touchcancel.' + this.props.name + this.instanceID, this.touchEndDelegate);

        this.touchMoveDelegate = undefined;
        this.touchEndDelegate = undefined;

        this.changeMouseState(0);

        if(this.props.onMouseUp)  this.props.onMouseUp({x: this.activeTouch.clientX, y: this.activeTouch.clientY});
        this.activeTouch = undefined;

        //console.log('touch end');
    }

    render()    {
        return null;
    }
}

OEMouseTracker.defaultProps = {
    disabled: false
};

OEMouseTracker.propTypes = {
    element: PropTypes.object,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onMouseDown: PropTypes.func,
    onMouseMove: PropTypes.func,
    onMouseUp: PropTypes.func,
    onMouseState: PropTypes.func
};